import ShPopconfirm from '@/components/Helpers/ShPopconfirm';

// @vue/component
export default {
  name: 'BlacklistListItem',

  components: {
    ShPopconfirm,
  },

  props: {
    element: {
      type: Object,
      default: () => ({}),
    },
  },

  methods: {
    async handleDeleteElement() {
      await this.$store.dispatch('blacklist/delete', this.element.id);
      this.$notify.success({
        title: 'Usunięto element z czarnej isty',
        message: `Usunięto: ${this.element.value} z czarnej listy`,
        customClass: 'callmeweb-notification',
      });
      this.$store.dispatch('blacklist/getList');
    },
  },
};
